// extracted by mini-css-extract-plugin
module.exports = {"title":"section_title__DLHOs","content":"section_content__3bs1w"};